/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
import e, { createContext as t, useState as r, useCallback as o, useMemo as n, useContext as l, useRef as i, useEffect as c, useLayoutEffect as a } from "react";
import { arrow as s, computePosition as u, offset as d, flip as p, shift as v, autoUpdate as m } from "@floating-ui/dom";
import y from "classnames";
const f = "react-tooltip-core-styles",
  h = "react-tooltip-base-styles",
  w = {
    core: !1,
    base: !1
  };
function b(_ref) {
  let {
    css: e,
    id: t = h,
    type: r = "base",
    ref: o
  } = _ref;
  var n, l;
  if (!e || "undefined" == typeof document || w[r]) return;
  if ("core" === r && "undefined" != typeof process && (null === (n = null === process || void 0 === process ? void 0 : process.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
  if ("base" !== r && "undefined" != typeof process && (null === (l = null === process || void 0 === process ? void 0 : process.env) || void 0 === l ? void 0 : l.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  "core" === r && (t = f), o || (o = {});
  const {
    insertAt: i
  } = o;
  if (document.getElementById(t)) return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
  const c = document.head || document.getElementsByTagName("head")[0],
    a = document.createElement("style");
  a.id = t, a.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(a, c.firstChild) : c.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e)), w[r] = !0;
}
function S() {
  let {
    type: e = "base",
    id: t = h
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!w[e]) return;
  "core" === e && (t = f);
  const r = document.getElementById(t);
  "style" === (null == r ? void 0 : r.tagName) ? null == r || r.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), w[e] = !1;
}
const E = (e, t, r) => {
    let o = null;
    return function () {
      for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
        n[_key] = arguments[_key];
      }
      const l = () => {
        o = null, r || e.apply(this, n);
      };
      r && !o && (e.apply(this, n), o = setTimeout(l, t)), r || (o && clearTimeout(o), o = setTimeout(l, t));
    };
  },
  _ = "DEFAULT_TOOLTIP_ID",
  g = {
    anchorRefs: new Set(),
    activeAnchor: {
      current: null
    },
    attach: () => {},
    detach: () => {},
    setActiveAnchor: () => {}
  },
  A = t({
    getTooltipData: () => g
  }),
  T = _ref2 => {
    let {
      children: t
    } = _ref2;
    const [l, i] = r({
        [_]: new Set()
      }),
      [c, a] = r({
        [_]: {
          current: null
        }
      }),
      s = function (e) {
        for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          t[_key2 - 1] = arguments[_key2];
        }
        i(r => {
          var o;
          const n = null !== (o = r[e]) && void 0 !== o ? o : new Set();
          return t.forEach(e => n.add(e)), {
            ...r,
            [e]: new Set(n)
          };
        });
      },
      u = function (e) {
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        i(r => {
          const o = r[e];
          return o ? (t.forEach(e => o.delete(e)), {
            ...r
          }) : r;
        });
      },
      d = o(function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
        var t, r;
        return {
          anchorRefs: null !== (t = l[e]) && void 0 !== t ? t : new Set(),
          activeAnchor: null !== (r = c[e]) && void 0 !== r ? r : {
            current: null
          },
          attach: function () {
            for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t[_key4] = arguments[_key4];
            }
            return s(e, ...t);
          },
          detach: function () {
            for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              t[_key5] = arguments[_key5];
            }
            return u(e, ...t);
          },
          setActiveAnchor: t => ((e, t) => {
            a(r => {
              var o;
              return (null === (o = r[e]) || void 0 === o ? void 0 : o.current) === t.current ? r : {
                ...r,
                [e]: t
              };
            });
          })(e, t)
        };
      }, [l, c, s, u]),
      p = n(() => ({
        getTooltipData: d
      }), [d]);
    return e.createElement(A.Provider, {
      value: p
    }, t);
  };
function O() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
  return l(A).getTooltipData(e);
}
const L = _ref3 => {
    let {
      tooltipId: t,
      children: r,
      className: o,
      place: n,
      content: l,
      html: a,
      variant: s,
      offset: u,
      wrapper: d,
      events: p,
      positionStrategy: v,
      delayShow: m,
      delayHide: f
    } = _ref3;
    const {
        attach: h,
        detach: w
      } = O(t),
      b = i(null);
    return c(() => (h(b), () => {
      w(b);
    }), []), e.createElement("span", {
      ref: b,
      className: y("react-tooltip-wrapper", o),
      "data-tooltip-place": n,
      "data-tooltip-content": l,
      "data-tooltip-html": a,
      "data-tooltip-variant": s,
      "data-tooltip-offset": u,
      "data-tooltip-wrapper": d,
      "data-tooltip-events": p,
      "data-tooltip-position-strategy": v,
      "data-tooltip-delay-show": m,
      "data-tooltip-delay-hide": f
    }, r);
  },
  R = "undefined" != typeof window ? a : c,
  N = e => {
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return ["overflow", "overflow-x", "overflow-y"].some(e => {
      const r = t.getPropertyValue(e);
      return "auto" === r || "scroll" === r;
    });
  },
  k = e => {
    if (!e) return null;
    let t = e.parentElement;
    for (; t;) {
      if (N(t)) return t;
      t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  },
  x = async _ref4 => {
    let {
      elementReference: e = null,
      tooltipReference: t = null,
      tooltipArrowReference: r = null,
      place: o = "top",
      offset: n = 10,
      strategy: l = "absolute",
      middlewares: i = [d(Number(n)), p(), v({
        padding: 5
      })],
      border: c
    } = _ref4;
    if (!e) return {
      tooltipStyles: {},
      tooltipArrowStyles: {},
      place: o
    };
    if (null === t) return {
      tooltipStyles: {},
      tooltipArrowStyles: {},
      place: o
    };
    const a = i;
    return r ? (a.push(s({
      element: r,
      padding: 5
    })), u(e, t, {
      placement: o,
      strategy: l,
      middleware: a
    }).then(_ref5 => {
      let {
        x: e,
        y: t,
        placement: r,
        middlewareData: o
      } = _ref5;
      var n, l;
      const i = {
          left: `${e}px`,
          top: `${t}px`,
          border: c
        },
        {
          x: a,
          y: s
        } = null !== (n = o.arrow) && void 0 !== n ? n : {
          x: 0,
          y: 0
        },
        u = null !== (l = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[r.split("-")[0]]) && void 0 !== l ? l : "bottom",
        d = c && {
          borderBottom: c,
          borderRight: c
        };
      let p = 0;
      if (c) {
        const e = `${c}`.match(/(\d+)px/);
        p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
      }
      return {
        tooltipStyles: i,
        tooltipArrowStyles: {
          left: null != a ? `${a}px` : "",
          top: null != s ? `${s}px` : "",
          right: "",
          bottom: "",
          ...d,
          [u]: `-${4 + p}px`
        },
        place: r
      };
    })) : u(e, t, {
      placement: "bottom",
      strategy: l,
      middleware: a
    }).then(_ref6 => {
      let {
        x: e,
        y: t,
        placement: r
      } = _ref6;
      return {
        tooltipStyles: {
          left: `${e}px`,
          top: `${t}px`
        },
        tooltipArrowStyles: {},
        place: r
      };
    });
  };
var C = "core-styles-module_tooltip__3vRRp",
  $ = "core-styles-module_fixed__pcSol",
  I = "core-styles-module_arrow__cvMwQ",
  j = "core-styles-module_noArrow__xock6",
  B = "core-styles-module_clickable__ZuTTB",
  D = "core-styles-module_show__Nt9eE",
  H = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
  };
const z = _ref7 => {
    let {
      id: t,
      className: n,
      classNameArrow: l,
      variant: a = "dark",
      anchorId: s,
      anchorSelect: u,
      place: d = "top",
      offset: p = 10,
      events: v = ["hover"],
      openOnClick: f = !1,
      positionStrategy: h = "absolute",
      middlewares: w,
      wrapper: b,
      delayShow: S = 0,
      delayHide: _ = 0,
      float: g = !1,
      hidden: A = !1,
      noArrow: T = !1,
      clickable: L = !1,
      closeOnEsc: N = !1,
      closeOnScroll: z = !1,
      closeOnResize: q = !1,
      style: W,
      position: M,
      afterShow: P,
      afterHide: F,
      content: K,
      contentWrapperRef: U,
      isOpen: X,
      setIsOpen: Y,
      activeAnchor: V,
      setActiveAnchor: Z,
      border: G,
      opacity: J,
      arrowColor: Q
    } = _ref7;
    const ee = i(null),
      te = i(null),
      re = i(null),
      oe = i(null),
      [ne, le] = r(d),
      [ie, ce] = r({}),
      [ae, se] = r({}),
      [ue, de] = r(!1),
      [pe, ve] = r(!1),
      me = i(!1),
      ye = i(null),
      {
        anchorRefs: fe,
        setActiveAnchor: he
      } = O(t),
      we = i(!1),
      [be, Se] = r([]),
      Ee = i(!1),
      _e = f || v.includes("click");
    R(() => (Ee.current = !0, () => {
      Ee.current = !1;
    }), []), c(() => {
      if (!ue) {
        const e = setTimeout(() => {
          ve(!1);
        }, 150);
        return () => {
          clearTimeout(e);
        };
      }
      return () => null;
    }, [ue]);
    const ge = e => {
      Ee.current && (e && ve(!0), setTimeout(() => {
        Ee.current && (null == Y || Y(e), void 0 === X && de(e));
      }, 10));
    };
    c(() => {
      if (void 0 === X) return () => null;
      X && ve(!0);
      const e = setTimeout(() => {
        de(X);
      }, 10);
      return () => {
        clearTimeout(e);
      };
    }, [X]), c(() => {
      ue !== me.current && (me.current = ue, ue ? null == P || P() : null == F || F());
    }, [ue]);
    const Ae = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _;
        oe.current && clearTimeout(oe.current), oe.current = setTimeout(() => {
          we.current || ge(!1);
        }, e);
      },
      Te = e => {
        var t;
        if (!e) return;
        const r = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == r ? void 0 : r.isConnected)) return Z(null), void he({
          current: null
        });
        S ? (re.current && clearTimeout(re.current), re.current = setTimeout(() => {
          ge(!0);
        }, S)) : ge(!0), Z(r), he({
          current: r
        }), oe.current && clearTimeout(oe.current);
      },
      Oe = () => {
        L ? Ae(_ || 100) : _ ? Ae() : ge(!1), re.current && clearTimeout(re.current);
      },
      Le = _ref8 => {
        let {
          x: e,
          y: t
        } = _ref8;
        x({
          place: d,
          offset: p,
          elementReference: {
            getBoundingClientRect: () => ({
              x: e,
              y: t,
              width: 0,
              height: 0,
              top: t,
              left: e,
              right: e,
              bottom: t
            })
          },
          tooltipReference: ee.current,
          tooltipArrowReference: te.current,
          strategy: h,
          middlewares: w,
          border: G
        }).then(e => {
          Object.keys(e.tooltipStyles).length && ce(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && se(e.tooltipArrowStyles), le(e.place);
        });
      },
      Re = e => {
        if (!e) return;
        const t = e,
          r = {
            x: t.clientX,
            y: t.clientY
          };
        Le(r), ye.current = r;
      },
      Ne = e => {
        Te(e), _ && Ae();
      },
      ke = e => {
        var t;
        [document.querySelector(`[id='${s}']`), ...be].some(t => null == t ? void 0 : t.contains(e.target)) || (null === (t = ee.current) || void 0 === t ? void 0 : t.contains(e.target)) || (ge(!1), re.current && clearTimeout(re.current));
      },
      xe = E(Te, 50, !0),
      Ce = E(Oe, 50, !0),
      $e = o(() => {
        M ? Le(M) : g ? ye.current && Le(ye.current) : x({
          place: d,
          offset: p,
          elementReference: V,
          tooltipReference: ee.current,
          tooltipArrowReference: te.current,
          strategy: h,
          middlewares: w,
          border: G
        }).then(e => {
          Ee.current && (Object.keys(e.tooltipStyles).length && ce(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && se(e.tooltipArrowStyles), le(e.place));
        });
      }, [ue, V, K, W, d, p, h, M, g]);
    c(() => {
      var e, t;
      const r = new Set(fe);
      be.forEach(e => {
        r.add({
          current: e
        });
      });
      const o = document.querySelector(`[id='${s}']`);
      o && r.add({
        current: o
      });
      const n = () => {
          ge(!1);
        },
        l = k(V),
        i = k(ee.current);
      z && (window.addEventListener("scroll", n), null == l || l.addEventListener("scroll", n), null == i || i.addEventListener("scroll", n));
      let c = null;
      q ? window.addEventListener("resize", n) : V && ee.current && (c = m(V, ee.current, $e, {
        ancestorResize: !0,
        elementResize: !0,
        layoutShift: !0
      }));
      const a = e => {
        "Escape" === e.key && ge(!1);
      };
      N && window.addEventListener("keydown", a);
      const u = [];
      _e ? (window.addEventListener("click", ke), u.push({
        event: "click",
        listener: Ne
      })) : (u.push({
        event: "mouseenter",
        listener: xe
      }, {
        event: "mouseleave",
        listener: Ce
      }, {
        event: "focus",
        listener: xe
      }, {
        event: "blur",
        listener: Ce
      }), g && u.push({
        event: "mousemove",
        listener: Re
      }));
      const d = () => {
          we.current = !0;
        },
        p = () => {
          we.current = !1, Oe();
        };
      return L && !_e && (null === (e = ee.current) || void 0 === e || e.addEventListener("mouseenter", d), null === (t = ee.current) || void 0 === t || t.addEventListener("mouseleave", p)), u.forEach(_ref9 => {
        let {
          event: e,
          listener: t
        } = _ref9;
        r.forEach(r => {
          var o;
          null === (o = r.current) || void 0 === o || o.addEventListener(e, t);
        });
      }), () => {
        var e, t;
        z && (window.removeEventListener("scroll", n), null == l || l.removeEventListener("scroll", n), null == i || i.removeEventListener("scroll", n)), q ? window.removeEventListener("resize", n) : null == c || c(), _e && window.removeEventListener("click", ke), N && window.removeEventListener("keydown", a), L && !_e && (null === (e = ee.current) || void 0 === e || e.removeEventListener("mouseenter", d), null === (t = ee.current) || void 0 === t || t.removeEventListener("mouseleave", p)), u.forEach(_ref10 => {
          let {
            event: e,
            listener: t
          } = _ref10;
          r.forEach(r => {
            var o;
            null === (o = r.current) || void 0 === o || o.removeEventListener(e, t);
          });
        });
      };
    }, [V, $e, pe, fe, be, N, v]), c(() => {
      let e = null != u ? u : "";
      !e && t && (e = `[data-tooltip-id='${t}']`);
      const r = new MutationObserver(r => {
        const o = [];
        r.forEach(r => {
          if ("attributes" === r.type && "data-tooltip-id" === r.attributeName) {
            r.target.getAttribute("data-tooltip-id") === t && o.push(r.target);
          }
          if ("childList" === r.type && (V && [...r.removedNodes].some(e => {
            var t;
            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, V)) && (ve(!1), ge(!1), Z(null), re.current && clearTimeout(re.current), oe.current && clearTimeout(oe.current), !0);
          }), e)) try {
            const t = [...r.addedNodes].filter(e => 1 === e.nodeType);
            o.push(...t.filter(t => t.matches(e))), o.push(...t.flatMap(t => [...t.querySelectorAll(e)]));
          } catch (e) {}
        }), o.length && Se(e => [...e, ...o]);
      });
      return r.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-tooltip-id"]
      }), () => {
        r.disconnect();
      };
    }, [t, u, V]), c(() => {
      $e();
    }, [$e]), c(() => {
      if (!(null == U ? void 0 : U.current)) return () => null;
      const e = new ResizeObserver(() => {
        $e();
      });
      return e.observe(U.current), () => {
        e.disconnect();
      };
    }, [K, null == U ? void 0 : U.current]), c(() => {
      var e;
      const t = document.querySelector(`[id='${s}']`),
        r = [...be, t];
      V && r.includes(V) || Z(null !== (e = be[0]) && void 0 !== e ? e : t);
    }, [s, be, V]), c(() => () => {
      re.current && clearTimeout(re.current), oe.current && clearTimeout(oe.current);
    }, []), c(() => {
      let e = u;
      if (!e && t && (e = `[data-tooltip-id='${t}']`), e) try {
        const t = Array.from(document.querySelectorAll(e));
        Se(t);
      } catch (e) {
        Se([]);
      }
    }, [t, u]);
    const Ie = !A && K && ue && Object.keys(ie).length > 0;
    return pe ? e.createElement(b, {
      id: t,
      role: "tooltip",
      className: y("react-tooltip", C, H.tooltip, H[a], n, `react-tooltip__place-${ne}`, {
        "react-tooltip__show": Ie,
        [D]: Ie,
        [$]: "fixed" === h,
        [B]: L
      }),
      style: {
        ...W,
        ...ie,
        opacity: void 0 !== J && Ie ? J : void 0
      },
      ref: ee
    }, K, e.createElement(b, {
      className: y("react-tooltip-arrow", I, H.arrow, l, {
        [j]: T
      }),
      style: {
        ...ae,
        background: Q ? `linear-gradient(to right bottom, transparent 50%, ${Q} 50%)` : void 0
      },
      ref: te
    })) : null;
  },
  q = _ref11 => {
    let {
      content: t
    } = _ref11;
    return e.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  },
  W = _ref12 => {
    let {
      id: t,
      anchorId: o,
      anchorSelect: n,
      content: l,
      html: a,
      render: s,
      className: u,
      classNameArrow: d,
      variant: p = "dark",
      place: v = "top",
      offset: m = 10,
      wrapper: y = "div",
      children: f = null,
      events: h = ["hover"],
      openOnClick: w = !1,
      positionStrategy: b = "absolute",
      middlewares: S,
      delayShow: E = 0,
      delayHide: _ = 0,
      float: g = !1,
      hidden: A = !1,
      noArrow: T = !1,
      clickable: L = !1,
      closeOnEsc: R = !1,
      closeOnScroll: N = !1,
      closeOnResize: k = !1,
      style: x,
      position: C,
      isOpen: $,
      disableStyleInjection: I = !1,
      border: j,
      opacity: B,
      arrowColor: D,
      setIsOpen: H,
      afterShow: W,
      afterHide: M
    } = _ref12;
    const [P, F] = r(l),
      [K, U] = r(a),
      [X, Y] = r(v),
      [V, Z] = r(p),
      [G, J] = r(m),
      [Q, ee] = r(E),
      [te, re] = r(_),
      [oe, ne] = r(g),
      [le, ie] = r(A),
      [ce, ae] = r(y),
      [se, ue] = r(h),
      [de, pe] = r(b),
      [ve, me] = r(null),
      ye = i(I),
      {
        anchorRefs: fe,
        activeAnchor: he
      } = O(t),
      we = e => null == e ? void 0 : e.getAttributeNames().reduce((t, r) => {
        var o;
        if (r.startsWith("data-tooltip-")) {
          t[r.replace(/^data-tooltip-/, "")] = null !== (o = null == e ? void 0 : e.getAttribute(r)) && void 0 !== o ? o : null;
        }
        return t;
      }, {}),
      be = e => {
        const t = {
          place: e => {
            var t;
            Y(null !== (t = e) && void 0 !== t ? t : v);
          },
          content: e => {
            F(null != e ? e : l);
          },
          html: e => {
            U(null != e ? e : a);
          },
          variant: e => {
            var t;
            Z(null !== (t = e) && void 0 !== t ? t : p);
          },
          offset: e => {
            J(null === e ? m : Number(e));
          },
          wrapper: e => {
            var t;
            ae(null !== (t = e) && void 0 !== t ? t : y);
          },
          events: e => {
            const t = null == e ? void 0 : e.split(" ");
            ue(null != t ? t : h);
          },
          "position-strategy": e => {
            var t;
            pe(null !== (t = e) && void 0 !== t ? t : b);
          },
          "delay-show": e => {
            ee(null === e ? E : Number(e));
          },
          "delay-hide": e => {
            re(null === e ? _ : Number(e));
          },
          float: e => {
            ne(null === e ? g : "true" === e);
          },
          hidden: e => {
            ie(null === e ? A : "true" === e);
          }
        };
        Object.values(t).forEach(e => e(null)), Object.entries(e).forEach(_ref13 => {
          let [e, r] = _ref13;
          var o;
          null === (o = t[e]) || void 0 === o || o.call(t, r);
        });
      };
    c(() => {
      F(l);
    }, [l]), c(() => {
      U(a);
    }, [a]), c(() => {
      Y(v);
    }, [v]), c(() => {
      Z(p);
    }, [p]), c(() => {
      J(m);
    }, [m]), c(() => {
      ee(E);
    }, [E]), c(() => {
      re(_);
    }, [_]), c(() => {
      ne(g);
    }, [g]), c(() => {
      ie(A);
    }, [A]), c(() => {
      pe(b);
    }, [b]), c(() => {
      ye.current !== I && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [I]), c(() => {
      "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
        detail: {
          disableCore: "core" === I,
          disableBase: I
        }
      }));
    }, []), c(() => {
      var e;
      const r = new Set(fe);
      let l = n;
      if (!l && t && (l = `[data-tooltip-id='${t}']`), l) try {
        document.querySelectorAll(l).forEach(e => {
          r.add({
            current: e
          });
        });
      } catch (e) {
        console.warn(`[react-tooltip] "${l}" is not a valid CSS selector`);
      }
      const i = document.querySelector(`[id='${o}']`);
      if (i && r.add({
        current: i
      }), !r.size) return () => null;
      const c = null !== (e = null != ve ? ve : i) && void 0 !== e ? e : he.current,
        a = new MutationObserver(e => {
          e.forEach(e => {
            var t;
            if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
            const r = we(c);
            be(r);
          });
        }),
        s = {
          attributes: !0,
          childList: !1,
          subtree: !1
        };
      if (c) {
        const e = we(c);
        be(e), a.observe(c, s);
      }
      return () => {
        a.disconnect();
      };
    }, [fe, he, ve, o, n]), c(() => {
      (null == x ? void 0 : x.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), j && !CSS.supports("border", `${j}`) && console.warn(`[react-tooltip] "${j}" is not a valid \`border\`.`), (null == x ? void 0 : x.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), B && !CSS.supports("opacity", `${B}`) && console.warn(`[react-tooltip] "${B}" is not a valid \`opacity\`.`);
    }, []);
    let Se = f;
    const Ee = i(null);
    if (s) {
      const t = s({
        content: null != P ? P : null,
        activeAnchor: ve
      });
      Se = t ? e.createElement("div", {
        ref: Ee,
        className: "react-tooltip-content-wrapper"
      }, t) : null;
    } else P && (Se = P);
    K && (Se = e.createElement(q, {
      content: K
    }));
    const _e = {
      id: t,
      anchorId: o,
      anchorSelect: n,
      className: u,
      classNameArrow: d,
      content: Se,
      contentWrapperRef: Ee,
      place: X,
      variant: V,
      offset: G,
      wrapper: ce,
      events: se,
      openOnClick: w,
      positionStrategy: de,
      middlewares: S,
      delayShow: Q,
      delayHide: te,
      float: oe,
      hidden: le,
      noArrow: T,
      clickable: L,
      closeOnEsc: R,
      closeOnScroll: N,
      closeOnResize: k,
      style: x,
      position: C,
      isOpen: $,
      border: j,
      opacity: B,
      arrowColor: D,
      setIsOpen: H,
      afterShow: W,
      afterHide: M,
      activeAnchor: ve,
      setActiveAnchor: e => me(e)
    };
    return e.createElement(z, {
      ..._e
    });
  };
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", e => {
  e.detail.disableCore || b({
    css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9}.core-styles-module_tooltip__3vRRp{visibility:hidden;position:absolute;top:0;left:0;pointer-events:none;opacity:0;transition:opacity 0.3s ease-out;will-change:opacity,visibility}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{visibility:visible;opacity:var(--rt-opacity)}`,
    type: "core"
  }), e.detail.disableBase || b({
    css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
    type: "base"
  });
});
export { W as Tooltip, T as TooltipProvider, L as TooltipWrapper, S as removeStyle };